import React, { Component } from 'react'
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import "react-tabs/style/react-tabs.css";
import axios from 'axios';
import { getAPIHostURL } from '../../ClientConfig';

export class VcSmartHmmAppLinks extends Component {
    constructor(props) {
        super(props)
        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: 'smartHHMdevApp',
            SmartHMMdevAppVersion: "",
            AppInformationArr: [],
            errors: {
                others: ""
            }
        }
    }

    componentDidMount() {
        this.getCalibAppVersions();
    }

    toggle(tab) {
        let modifiedState = this.state;
        if (modifiedState.activeTab !== tab) {
            modifiedState.activeTab = tab;
        } else {
            modifiedState.activeTab = modifiedState.activeTab;
        }
        
        this.setState(modifiedState);
    }
    
    getCalibAppVersions = () => {

        let modifiedState = this.state;

        modifiedState.SmartHMMdevAppVersion = "";
        modifiedState.errors.others = "";

        axios.post( `${getAPIHostURL()}/wclient/getMobileAppDetails`)
        .then(response => {
            if(response.data.code == 'SUCCESS') {    
                modifiedState.AppInformationArr = [];
                modifiedState.AppInformationArr = response.data.retrivedAppInformation;
                if(modifiedState.AppInformationArr != null && modifiedState.AppInformationArr.length > 0) {
                    for(let i = 0; i<modifiedState.AppInformationArr.length; i++) {
                        if(modifiedState.AppInformationArr[i]["AppName"] == "SmartHHMdevApp" && modifiedState.AppInformationArr[i]["Platform"] == "ANDR") {
                            modifiedState.SmartHMMdevAppVersion = modifiedState.AppInformationArr[i]["AppVersion"]
                        }
                    }
                } else {
                    modifiedState.errors.others = 'App Details Not Present On Server.';
                }   
            } else {
                if(response.data.code == 'SQL_ERROR') {
                    // Tell the user that Server is experiencing errors
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                } else {
                    console.log('Should not reach here');
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                }
            }
            this.setState(modifiedState);
        })
        .catch( error => {
            console.log("Network error:");
            console.log(error);
            if (axios.isCancel(error)) {
                console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
            } else {
                // Tell the user that there are network issues
                modifiedState.errors.others = 'Network issues.\nCheck your Internet and Try again later.';
                this.setState(modifiedState);
            }
        });
    }

    onClickGetSmartHHMdevApp = (e) => {
        window.open("https://drive.google.com/file/d/1KN8hInntUrw36XzoZbh5m2iZ9Reh8EJJ/view?usp=drive_link", "_blank");
    }

    onClickGetSmartHHMProdApp = () => {
        window.open("https://drive.google.com/file/d/1JwTBw3J-eZwm9IBKcj9F8u7JRer22rfw/view?usp=drive_link", "_blank");
    }

    render() {
        return (
            <div className="container">
                <div className="row align-items-center"  style={{height: "70vh"}}>
                    <div style={{marginBottom: "1rem", marginTop: "1rem", border:"1px solid black", paddingLeft: "0.3rem", paddingRight: "0.3rem", borderRadius:"0.5rem", paddingBottom: "0.4rem"}}>
                        <div style={{border:"1px solid var(--primaryColor)", marginTop: "1rem", color:"green", fontSize:"0.8rem", alignItems: "left", 
                            textAlign: "left", paddingLeft: "0.2rem", paddingRight: "0.2rem", backgroundColor:"rgb(168,204,168,0.3)", borderRadius:"0.5rem", marginBottom:"0.5rem"}}>
                            <div style = {{padding: "0.5rem"}}>
                                <b>Note:</b>
                                <ul style={{marginBottom: "0.2rem"}}>
                                    <li>                                
                                        By clicking on the respective button you will be redirected to the drive link from which you can download the current app apk.
                                    </li>                                
                                    <li>
                                        Please uninstall the previous app before downloading the new app apk.
                                    </li>
                                </ul> 
                            </div>
                        </div>
                    </div>
                    <div className="container col-lg-8 col-lg-offset-3 centered col-md-6 col-md-offset-3 p-1">
                        <div className="modal-body box" style = {{padding:"1rem"}}>
                            <form>
                                <Nav tabs className="tabular">
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab == 'smartHHMdevApp' })}
                                            onClick={() => { this.toggle('smartHHMdevApp'); }}>
                                            <b>SmartHHM App</b>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={this.state.activeTab}>
                                    <TabPane tabId="smartHHMdevApp" className="tabular2">
                                        <Row>
                                            <Col sm="12">
                                                <div className="form-group reg-form">
                                                    <div className="inputgroupCustom" style={{paddingTop:"1rem"}}>
                                                        <label className="reg-form-label">SmartHMM Dev App Latest Version</label>
                                                        <button type="button" className="btn-lg logbtn" 
                                                            style={{padding:"0.4rem", borderRadius:"5px", width:"100%", marginTop:"0.2rem", textTransform: "none",
                                                                backgroundColor :"var(--primaryColor)", borderColor: "var(--primaryColor)", color: "white", borderRadius: "0.5rem"
                                                            }} 
                                                            onClick={this.onClickGetSmartHHMdevApp}> 
                                                            SmartHMM Android App for Development    
                                                        </button>
                                                    </div>
                                                </div>
                                            </Col> 
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="smartHHMdevApp" className="tabular2">
                                        <Row>
                                            <Col sm="12">
                                                <div className="form-group reg-form">
                                                    <div className="inputgroupCustom" style={{paddingTop:"1rem"}}>
                                                        <label className="reg-form-label">SmartHMM Prod App Latest Version</label>
                                                        <button type="button" className="btn-lg logbtn" 
                                                            style={{padding:"0.4rem", borderRadius:"5px", width:"100%", marginTop:"0.2rem", textTransform: "none",
                                                                backgroundColor :"var(--primaryColor)", borderColor: "var(--primaryColor)", color: "white", borderRadius: "0.5rem"
                                                            }} 
                                                            onClick={this.onClickGetSmartHHMProdApp}> 
                                                            SmartHMM Android App for Production 
                                                        </button>
                                                    </div>
                                                </div>
                                            </Col> 
                                        </Row>
                                    </TabPane>
                                </TabContent> 
                                <div style={{textAlign: "center"}}>
                                    {this.state.errors.others.length != null && this.state.errors.others.length > 0 && <span style={{color: "red", fontSize: "0.8rem"}} className="inlineCSS">{this.state.errors.others}</span>}
                                </div>
                            </form>  
                        </div>                    
                    </div>
                </div>
            </div>  
        )
    }
}

export default VcSmartHmmAppLinks;